export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10167.25585b90.jpg";